module.exports = __webpack_public_path__ + "img/1.fe124dd6.jpg";